import { render } from "./NewsletterSubscriptionVerificationSuccess.vue?vue&type=template&id=66a5b9e8"
import script from "./NewsletterSubscriptionVerificationSuccess.vue?vue&type=script&lang=js"
export * from "./NewsletterSubscriptionVerificationSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rebecca/Workspace/repositories/mercator/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__